<template>
  <div>
    <article
      id="ignoreFontUpscale"
      class="ignoreFontUpscale tw-flex tw-flex-col"
    >
      <div class="tw-px-16 tw-pb-[120px] tw-pt-[68px] tw-text-center">
        <VText v-once html-tag="h1" cfg="sans/24/bold">{{
          $t('contact00')
        }}</VText>
        <VText v-once html-tag="p" cfg="sans/18/normal" class="tw-mt-2">
          <span>{{ $t('contact01') }}</span>
          <br />
          <span>{{ $t('contact02') }}</span>
          <br />
          <br />
          <span>{{ $t('contact04') }}</span>
          <a
            href="https://help.groover.co/fr/"
            rel="external"
            class="tw-font-bold"
            >{{ $t('contact05') }}</a
          >
          <span>{{ $t('contact06') }}</span>
          <NuxtLinkLocale to="/lp/about/" class="tw-font-bold">
            {{ $t('contact07') }}
          </NuxtLinkLocale>
          <span>{{ $t('contact08') }}</span>
        </VText>
      </div>
    </article>
    <div class="mainParentContainer ignoreFontUpscale">
      <SeoFooter :lists="seoListing" />
    </div>
    <PageFooter />
  </div>
</template>

<script setup lang="ts">
import SeoFooter from '~/components/seo/footer/index.vue'
import PageFooter from '~/components/shared/footer/index.vue'
import VText from '~/components/ui/VText.vue'

import { useGetSeoGenericCuratorList } from '~/composables/useGetSeoGenericCuratorList'

import { useTagStore } from '~/stores/tag'

const { FETCH: FETCH_TAGS } = useTagStore()

// head data setup
const { t } = useI18n()
const title = t('metaTags.contact.title')
const description = t('metaTags.contact.description')

useHead({
  script: [
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'ContactPage',
        mainContentOfPage: '.formWrapper',
        description: t('contact01'),
      }),
    },
  ],
  title,
  meta: [
    {
      name: 'description',
      key: 'description',
      content: description,
    },
    {
      key: 'og:title',
      property: 'og:title',
      content: title,
    },
    {
      key: 'og:description',
      property: 'og:description',
      content: description,
    },
  ],
})

const { data: seoListing } = await useGetSeoGenericCuratorList()

callOnce('FETCH_TAGS', FETCH_TAGS)
</script>
